import DynamoDB from 'aws-sdk/clients/dynamodb';
import {
  defaultEnvironmentSettings,
  EnvironmentSettingsItem
} from '../../api/environments/interface';

export const getEnvironmentSettings = async (
  envId: string
): Promise<EnvironmentSettingsItem> => {
  const ddb = new DynamoDB.DocumentClient();
  const item = await ddb
    .get({
      Key: {
        envId
      },
      TableName: 'environmentSettingsTable1'
    })
    .promise();
  const res = {
    ...defaultEnvironmentSettings,
    ...item.Item,
    ...{ envId }
  };
  return res;
};
